import { PageLayout } from "~/components/PageLayout";
import { ForgotPasswordForm } from "~/features/auth/components/ForgotPasswordForm";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const ForgotPasswordPage = () => {
  useTrackPageVisit("app/forgot_password/visit");

  return (
    <PageLayout>
      <ForgotPasswordForm />
    </PageLayout>
  );
};
